import React, {Component} from "react"
import PropTypes from "prop-types"

import authentication from "@irati/auth"
import {canModifyUserMembership} from "@irati/identity/utils/team/membership"

import User, {UserHeader, UserRemoveButton} from "../../Users/User"

class TeamUserListRender extends Component {
  static propTypes = {
    removeUserFromTeam: PropTypes.func.isRequired,
    team: PropTypes.any,
    users: PropTypes.array
  }

  static defaultProps = {
    users: []
  }

  constructor(props) {
    super(props)
    this.state = {}
  }

  action = (user) => {
    const {removeUserFromTeam} = this.props
    // Do not allow edit if current user is manager and target is admin
    if (canModifyUserMembership(this.props.team, authentication.user(), user)) {
      return <UserRemoveButton user={user} onRemove={() => removeUserFromTeam(user)} />
    }

    return null
  }

  render() {
    return (
      <div>
        <UserHeader header={null} />
        {this.props.users.map((user) => (
          <User key={user.uuid} user={user} team={this.props.team} showTeams={false} showCheckbox={false} action={this.action(user)} />
        ))}
      </div>
    )
  }
}

export default TeamUserListRender
